export default __webpack_public_path__ + "static/phone-no-clip-f524b2324857613ae97e892b830dcae6.avif";